export default function openFeedbackPage() {
    window.open('http://broadband.espn.com/espn360/watchespn/feedback', 'feedback', 'status=no,height=450,width=525,scrollbars=yes');
}



// WEBPACK FOOTER //
// ./app/lib/ui/openFeedbackPage.js